import { Layout } from 'antd';
const { Footer } = Layout;


function CustomFooter() {
  return (
    <div>
      <Footer style={{ textAlign: 'center', bottom:"0", position : "fixed", width : "100%", padding:"1%"}}>
          Screens ©2021 Created by Akshay
      </Footer>
    </div>
  );
}

export default CustomFooter;
